<template>
  <div ref="tablePage" style="height: 100%">
    <!-- 面包屑导航 -->
    <div class="topNav">
      <div class="navFormWrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/homePage' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>公司列表</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form
          ref="queryForm"
          :model="searchForm"
          inline
          label-width="68px"
          style="margin-left: 8vh"
        >
          <el-form-item style="margin-bottom: 0">
            <el-input
              v-model="searchForm.title"
              autocomplete="off"
              maxlength="30"
              placeholder="公司名称"
              clearable
              size="small"
              @change="searchChange"
            />
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-select
              v-model="searchForm.type"
              placeholder="请选择类型"
              clearable
              size="small"
              @change="searchChange"
              @clear="clearInput"
            >
              <el-option
                v-for="item in typeList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="searchChange"
              size="small"
              >搜索</el-button
            >
            <el-button
              type="success"
              style="margin-left: 2vh"
              icon="el-icon-plus"
              @click="handleNewAdd"
              size="mini"
              >新增公司</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table
      :data="tableList"
      style="width: 100%; margin-top: 2vh"
      border
      size="mini"
      :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }"
    >
      <el-table-column prop="title" label="公司名称" align="center" />
      <el-table-column prop="title" label="公司执照" align="center">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.license_img"
            :preview-src-list="[scope.row.license_img]"
            style="width: 80px; height: 80px"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="公司类型" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 1">总部</span>
          <span v-else-if="scope.row.type === 2">区域</span>
          <span v-else-if="scope.row.type === 3">分公司</span>
        </template>
      </el-table-column>
      <el-table-column prop="auth_code" label="公司授权码" align="center" />
      <el-table-column prop="wx_sub_mch_id" label="微信子商户号" align="center" />
      <el-table-column prop="wx_sub_mch_name" label="微信子商户名称" align="center" />
      <el-table-column prop="profit_sharing_ratio" label="租赁分账比例" align="center" />
      <el-table-column prop="created_at" label="创建时间" align="center" />
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            @change="changeStatus(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="360">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="handleClick(scope.row)"
            type="primary"
            size="small"
            icon="el-icon-edit"
          >
            修改
          </el-button>
          <el-button
            @click.native.prevent="singleDel(scope.row, scope.row.id)"
            type="danger"
            size="small"
            icon="el-icon-delete"
          >
            移除
          </el-button>
          <el-button
            @click.native.prevent="getCodes(scope.row, scope.row.id)"
            type="warning"
            size="small"
            icon="el-icon-edit"
          >
            生成授权码
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="searchForm.page"
      :limit.sync="searchForm.size"
      @pagination="initList"
    />
    <el-dialog
      :title="title"
      :visible.sync="addOrEditOpen"
      :close-on-click-modal="false"
      width="45%"
      class="global-dialog-position"
      :before-close="getout"
      style="margin-top: -7vh"
    >
      <el-form ref="form" :model="form" label-width="100px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="公司名称" prop="title">
              <el-input
                v-model="form.title"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="公司类型">
              <el-select
                v-model="form.type"
                placeholder="请选择类型"
                clearable
                style="width: 100%"
                @change="changType"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24" v-if="form.type == 3">
            <el-form-item label="分公司城市">
              <el-select
                v-model="form.city_id"
                placeholder="请选择城市"
                clearable
                @change="changeCi"
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="item in cityGroup"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="24" v-if="form.type == 3">
            <el-form-item label="上级公司">
              <el-select
                v-model="form.parentid"
                placeholder="请选择上级公司"
                clearable
                style="width: 100%"
                filterable
              >
                <el-option
                  v-for="item in companysArr"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="ip白名单" prop="api">
              <el-input
                v-model="form.api"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="营业执照">
              <el-upload
                class="avatar-uploader"
                :action="uploadImgUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :headers="headers"
                :disabled="true"
              >
                <div class="avatar-wrapper">
                  <el-image
                    v-if="form.license_img"
                    :src="form.license_img"
                    class="avatar"
                    :preview-src-list="[form.license_img]"
                  />
                  <i
                    v-if="form.license_img"
                    class="el-icon-close"
                    @click.stop="removePic"
                  ></i>
                  <i
                    v-else
                    class="el-icon-picture-outline avatar-uploader-icon"
                    @click="uploadPicIcon"
                  ></i>
                </div>
              </el-upload>
              <div class="chooseImg">
                <el-button type="info" @click="chooseImg(form.license_img)"
                  >选择图片</el-button
                >
                <el-input
                  v-model="form.license_img"
                  autocomplete="off"
                  placeholder="请输入"
                />
              </div>
              <!-- <i v-if="form.license_img" class="el-icon-close" @click="removePic"></i> -->
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="微信子商户号">
              <el-input
                v-model="form.wx_sub_mch_id"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="微信子商户名称">
              <el-input
                v-model="form.wx_sub_mch_name"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="租赁分账比例">
              <el-input
                v-model="form.profit_sharing_ratio"
                autocomplete="off"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="24">
            <el-form-item label="公司状态">
              <el-radio-group v-model="form.status">
                <el-radio
                  v-for="item in regionTypes"
                  :label="item.label"
                  :key="item.label"
                  >{{ item.text }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForms">确 定</el-button>
        <el-button @click="getout">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="图片"
      :visible.sync="upImg"
      :close-on-click-modal="false"
      width="85%"
      class="dialogHeight global-dialog-position"
      style="margin-top: -7vh"
    >
      <imgUpload ref="imgUpload" />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFormz">确 定</el-button>
        <!-- <el-button @click="getout">取 消</el-button> -->
      </div>
      <div slot="body" style="height: 50vh"></div>
    </el-dialog>
  </div>
</template>

<script>
import tableCommon from "../../../mixins/table-common";
import imgUpload from "../../components/uploadImg.vue";
import { getCookie } from "../../utils/util";
import {
  getCompanysList,
  addCompanyData,
  deleteCompany,
  editCompany,
} from "../../api/userMG";
import { getCityeList, getCode } from "../../api/city";

export default {
  mixins: [tableCommon],
  components: {
    imgUpload,
  },
  data() {
    return {
      typeList: [
        { id: 1, title: "总部" },
        { id: 2, title: "区域" },
        { id: 3, title: "分公司" },
      ],
      // 请求地址api
      api: {
        list: getCompanysList,
        add: addCompanyData,
        del: deleteCompany,
        edit: editCompany,
      },
      // 规则验证
      rules: {
        title: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      // 传参
      form: {
        status: "1",
      },
      // 弹窗标题
      title: "新增",
      addOrEditOpen: false,
      // 查询参数
      searchForm: {
        page: 1,
        size: 10,
      },
      tableData: [],
      // 公司类型
      companyType: false,
      // 上传头文件
      headers: {
        Authorization: "Bearer " + getCookie("logintoken"),
      },
      // 图片上传地址
      uploadImgUrl: process.env.VUE_APP_URL + "/admin/uploadFile",
      imgFirst: false,
      upImg: false,
      // 城市数组
      cityGroup: [],
      // 总公司数组
      companysArr: [],
    };
  },
  mounted() {
    // this.getCityeLists();
    this.getCompanyLists();
  },
  methods: {
    uploadPicIcon() {
      this.$message.warning("请点击下方选择图片按钮进行上传");
    },
    // 生成授权码
    getCodes(req) {
      console.log(req);
      this.$confirm(`确定生成新授权码?`, `生成授权码`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const form = {
          id: req.id,
        };
        const res = await getCode(form);
        if (res.code !== 200) return this.$message.error("生成失败");
        this.$message.success(`生成成功!`);
        this.initList();
      });
    },
    getCompanyLists() {
      getCompanysList({select:1}).then((res) => {
        console.log(res)
        this.companysArr = res.data.records;
      });
    },
    clearInput() {
      this.searchForm.type = undefined;
      this.searchChange();
    },
    changeCi(e) {
      console.log(e);
    },
    // 获取城市列表
    // getCityeLists() {
    //   const arr = {
    //     select: 1,
    //   };
    //   getCityeList(arr).then((res) => {
    //     this.cityGroup = res.data.data;
    //   });
    // },
    changType(e) {
      if (e == 3) {
        this.companyType = true;
      }
      // getCompanysList(type).then((res) => {
      //   console.log(res);
      // });
    },
    // 移除图片
    removePic() {
      this.form.license_img = "";
      // 清除form里的图片
      // this.form.headimg = "";
    },
    // 点击确定
    submitForms() {
      delete this.form.auth_code;
      delete this.form.created_at;
      this.submitForm();
    },
    submitFormz() {
      if (this.$refs.imgUpload.faData.url) {
        if (this.imgFirst && this.$refs.imgUpload.faData.url !== undefined) {
          this.$refs.imgUpload.findTrue();
          this.form.license_img = this.$refs.imgUpload.faData.url;
          // 将这张图片赋值
          // this.form.headimg = this.form.license_img;
          this.$forceUpdate();
        }
        this.$refs.imgUpload.faData.url = "";
        this.$refs.imgUpload.getimgLists();
        this.upImg = false;
      } else {
        this.$message.warning("请选择一张照片");
      }
    },
    chooseImg() {
      this.imgFirst = true;
      this.upImg = true;
    },
    handleAvatarSuccess(res, file) {
      this.form.license_img = res.data.path;
      // 将这张图片赋给字段
      // this.form.xiaoqu_img = this.form.license_img;
      this.$forceUpdate();
      //   this.form.sales_img = this.form.license_img;
      //   console.log(this.form.license_img);
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/webp";

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }

      return isJPG;
    },
    // 状态修改
    changeStatus(res) {
      this.form = JSON.parse(JSON.stringify(res));
      // this.handleEdit();
      this.actionType = "edit";
      // const { city_name, company_name, ...rest } = this.form;
      // this.form = rest;
      editCompany(this.form).then((msg) => {
        if (msg.code !== 200) return this.$message("获取状态失败");
      });
    },
    // 重置
    reset() {
      this.form = {
        status: undefined,
        title: undefined,
      };
    },
    // 新增弹窗
    handleNewAdd() {
      this.title = "新增";
      this.reset();
      this.form.status = 1;
      if (this.$refs.imgUpload) {
        this.$refs.imgUpload.faData.url = "";
      }
      this.$nextTick(() => {
        this.form.license_img = "";
      });
      this.handleAdd();
    },
    // 修改弹窗
    handleClick(row) {
      this.title = "修改";
      this.form = JSON.parse(JSON.stringify(row));
      if (this.$refs.imgUpload) {
        this.$refs.imgUpload.faData.url = "";
      }
      if (row.city_id) {
        this.form.city_id = parseInt(row.city_id);
      }
      this.handleEdit();
    },
    // 关闭弹窗
    getout() {
      this.addOrEditOpen = false;
      this.$refs.form.clearValidate();
    },
  },
};
</script>
<style scoped>
/deep/.dialogHeight .el-dialog__body {
  height: 100%;
  overflow: hidden;
}
/deep/ .el-dialog__body {
  height: 62vh;
  overflow-y: auto;
}
.chooseImg {
  display: flex;
  align-items: center;
}
/deep/.el-table,
.el-table th,
.el-table td {
  border-radius: 10px;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: 16px;
  font-family: Times, "Times New Roman";
  /* font-weight: 600; */
}
.topNav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 20px;
  border-radius: 10px;
}

.navFormWrapper {
  display: flex;
  align-items: center;
}
.avatar-wrapper {
  position: relative;
}

.avatar-wrapper img.avatar {
  max-width: 100%;
  max-height: 100%;
}

.avatar-wrapper .el-icon-close {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 18px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px;
  border-radius: 50%;
  cursor: pointer;
}
.navFormWrapper {
  display: flex;
  align-items: center;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px solid #dcdfe6;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}
.el-icon-close {
  position: absolute;
  top: 0;
  right: 7vh;
  cursor: pointer;
}
.closes {
  right: 54vh;
}
.el-icon-close:hover {
  color: #409eff;
}
.el-icon-close2 {
  position: absolute;
  top: 0;
  right: 55vh;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/views/companys/companys.vue